import DicomParserAdapter from "./adapter/DicomParserAdapter.js";
import NSDicomLoaderAdapter from "./adapter/NSDicomLoaderAdapter.js";

//import DicomParser from "dicom-parser";

function LoaderParserLibs(parserName) {
  if (typeof parserName !== "string") {
    throw new Error("Error : no supported dicom loader");
  }
  if (parserName === "" || parserName.toLowerCase() === "dicom-parser") {
    return DicomParserAdapter;
  } else if (parserName.toLowerCase() === "IAID-DicomParser".toLowerCase()) {
    return NSDicomLoaderAdapter;
  }
  return undefined;
}

export default LoaderParserLibs;
